import { OverlayType } from '../constants/common'
import SMA from './sma'

class SMA2 extends SMA {
  static type = OverlayType.Sma2
}

SMA2.prototype.defaults = { color: '#ff6400' }

export default SMA2
